import { render, staticRenderFns } from "./ISAInsightRoomTotalFalls.vue?vue&type=template&id=b0cbfcbc&scoped=true&"
import script from "./ISAInsightRoomTotalFalls.vue?vue&type=script&lang=js&"
export * from "./ISAInsightRoomTotalFalls.vue?vue&type=script&lang=js&"
import style0 from "./ISAInsightRoomTotalFalls.vue?vue&type=style&index=0&id=b0cbfcbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cbfcbc",
  null
  
)

export default component.exports